import { UPDATE_BASE_URL } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_BASE_URL:
            return action.payload
        default:
            return state
    }
}
